export const homepage = {
	homepage: {
		greeting: "こんにちは。私は",
		allProjects: "全てのプロジェクトを見る",
		latestArticles: "最新の記事",
		allArticles: "全ての記事を見る",
		work: {
			title: "職歴",
			company: "サイバーエージェント",
			position: "ソフトウェアエンジニア",
			duration: "2019年 - 現在",
		},
	},
} as const;
